import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslate } from '../../../mixins/translate/translate';
import { openApiFetchGet } from '../../../store/openApiFetch';
import { PanelRouterLink, Topbar, TopbarLeft, TopbarRight, TopbarWithTabs } from '../../elements';
import { useReactAsync } from '../../utils/useReactAsync';

async function loadEquipment({ equipmentId }: { equipmentId?: undefined | string }) {
    if (equipmentId) {
        const result = await openApiFetchGet('/api/equipment/{equipmentId}', { equipmentId });
        return result;
    }
    return undefined;
}

export function TopBar(props: { equipmentId?: undefined | string; activeTab: 'addEdit' | 'documents' | 'payload' }) {
    const translate = useTranslate();
    const { data } = useReactAsync(loadEquipment, { equipmentId: props.equipmentId }, []);

    return (
        <Topbar>
            <TopbarLeft>
                <TopbarWithTabs
                    icon="fa-plane"
                    title={props.equipmentId ? (data ? data.name : '') : translate('common.addItem', translate('equipment.equipment'))}
                >
                    <li className={props.activeTab === 'addEdit' ? 'active' : ''}>
                        <Link to={`/equipment/${props.equipmentId}/edit`}>{translate('equipment.equipment')}</Link>
                    </li>
                    <li className={props.activeTab === 'documents' ? 'active' : ''}>
                        <Link to={props.equipmentId ? `/equipment/${props.equipmentId}/documents` : '#'}>{translate('survey.documents')}</Link>
                    </li>
                    {data && !data.equipmentType.isPayload && (
                        <li className={props.activeTab === 'payload' ? 'active' : ''}>
                            <Link to={props.equipmentId ? `/equipment/${props.equipmentId}/payload` : '#'}>{translate('equipment.payload')}</Link>
                        </li>
                    )}
                </TopbarWithTabs>
            </TopbarLeft>
            {props.equipmentId && (
                <TopbarRight>
                    <PanelRouterLink
                        to={`/equipment/${props.equipmentId}`}
                        text={translate('common.showItem', translate('equipment.equipment'))}
                        icon="fa fa-search"
                        small={true}
                    />
                </TopbarRight>
            )}
        </Topbar>
    );
}
